import React, { useEffect, useState } from 'react'
import FilterListIcon from '@material-ui/icons/FilterList'
import {
   Button,
   Popper,
   List,
   ListItem,
   Typography,
   ListItemIcon,
   ListItemText,
   Checkbox,
   Grid,
   makeStyles,
   FormControl,
   ClickAwayListener,
   RadioGroup,
   Radio,
   FormLabel,
   FormControlLabel
} from '@material-ui/core'

import PortalModal, { usePortalModal } from 'components/commons/PortalModal'

import TRANSLATE from 'utils/constants'
import { useApiRequest } from 'utils/customHooks/useApiRequest'
import { getFromApi, patchToApi, postToApi } from 'actions'
import { useStateValue } from 'context/store'
import { userSettingsModule } from 'utils/utils'
import { closeSpinnerAction } from 'context/reducers/openSpinnerReducer'
import { openSnackBarAction } from 'context/reducers/openSnackbarReducer'
import { QUESTIONNAIRE } from '../constants'

const useStyles = makeStyles(theme => ({
   listWithAction: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: 'white'
   },
   popperContainer: {
      boxShadow:
         '0px 0px 5px rgba(63, 63, 68, 0.4), 0px 1px 3px rgba(63, 63, 68, 0.4)',
      borderRadius: '4px',
      zIndex: '1201'
   },
   popperWindowLayout: {
      padding: theme.spacing(0, 1),
      backgroundColor: theme.palette.background.paper,
      minWidth: '250px',
      borderRadius: '4px'
   },
   popperWindowLayoutForm: {
      padding: theme.spacing(0, 1),
      backgroundColor: theme.palette.background.paper,
      minWidth: '350px',
      borderRadius: '4px'
   },
   popperButton: {
      backgroundColor: '#1E57E11A',
      color: '#1E57E1',
      borderRadius: '20px',
      border: 'none',
      padding: '5px 10px'
   },
   popperButtonForm: {
      color: 'grey',
      borderRadius: '4px',
      border: '1px solid rgb(196 196 196)',
      padding: '10px 15px',
      height: '57px',
      width: '100%',
      textAlign: 'left',
      // width: '23.6vw',
      justifyContent: 'space-between'
   },
   listContainer: {
      overflowY: 'auto',
      maxHeight: '208px'
   },
   listItem: {
      borderBottom: '1px solid rgba(224, 224, 224, 0.5)'
   },
   title: {
      fontWeight: '500',
      fontSize: '13px',
      color: '#A7B0C6',
      padding: theme.spacing(2)
   },
   buttonContainer: {
      padding: theme.spacing(2, 0)
   },
   applyButton: {
      // backgroundColor: '#1E57E1',
      color: '#DFEAFF',
      padding: '1px 12px'
   },
   cancelButton: {
      color: '#1E57E1',
      padding: '1px 12px'
   },
   rolRadioGroup: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: 10
   }
}))
const ItemsListWithPrimaryAction = ({
   availableItemsListToApply,
   selectedItems,
   setSelectedItems
}) => {
   const classes = useStyles()

   const handleToggle = value => () => {
      const currentIndex = selectedItems.map(item => item).indexOf(value.id)
      const newSelectedItems = [...selectedItems]
      if (currentIndex === -1) {
         newSelectedItems.push(value.id)
      } else {
         newSelectedItems.splice(currentIndex, 1)
      }
      setSelectedItems(newSelectedItems)
   }

   return (
      <List className={classes.listWithAction}>
         {availableItemsListToApply.map(value => {
            const labelId = value.id
            return (
               <ListItem
                  key={value.id}
                  role={undefined}
                  dense
                  button
                  onClick={handleToggle(value)}
                  className={classes.listItem}
               >
                  <ListItemIcon>
                     <Checkbox
                        edge="start"
                        checked={
                           selectedItems.map(item => item).indexOf(value.id) !==
                           -1
                        }
                        tabIndex={-1}
                        disableRipple
                        inputProps={{ 'aria-labelledby': labelId }}
                        color="primary"
                     />
                  </ListItemIcon>
                  <ListItemText id={labelId} primary={value.name} />
               </ListItem>
            )
         })}
      </List>
   )
}

const PopperWindowLayout = ({
   setTypeUser,
   typeUser,
   setShowViewMultiSelect,
   cancelCallback,
   previousAppliedItemsList,
   setTypeUserForm,
   isStyleTable,
   isForm
}) => {
   const classes = useStyles()

   const handleChange = e => {
      setTypeUser(e.target.value)
      if (isForm) {
         setTypeUserForm(e.target.value)
      }
   }

   return (
      <Grid
         className={
            isStyleTable
               ? classes.popperWindowLayout
               : classes.popperWindowLayoutForm
         }
      >
         <Grid className={classes.listContainer}>
            <FormControl fullWidth style={{ margin: '10px auto' }}>
               <FormLabel id="demo-row-radio-buttons-group-label">
                  Seleccione tipo de usuario
               </FormLabel>
               <RadioGroup
                  row
                  onChange={handleChange}
                  variant="outlined"
                  margin="normal"
                  className={classes.rolRadioGroup}
               >
                  <FormControlLabel
                     value="rol"
                     control={<Radio color="primary" />}
                     label="Rol"
                  />
                  <FormControlLabel
                     value="grupo"
                     control={<Radio color="primary" />}
                     label="Grupo"
                  />
               </RadioGroup>
            </FormControl>
         </Grid>
         <Grid
            container
            justifyContent="space-evenly"
            className={classes.buttonContainer}
         >
            <Button className={classes.cancelButton} onClick={cancelCallback}>
               {TRANSLATE.BUTTONS.CANCEL}
            </Button>
            <Button
               disabled={!typeUser}
               variant="contained"
               color="primary"
               onClick={() => setShowViewMultiSelect(true)}
            >
               {TRANSLATE.BUTTONS.APPLY}
            </Button>
         </Grid>
      </Grid>
   )
}
const PopperWindowLayoutMultiSelect = ({
   questionnaireId,
   allActiveRoles,
   allActiveGroups,
   typeUser,
   // availableItemsListToApply,
   onApplyItemsToRowCallback,
   currentRowIdToApplyItems,
   popperWindowTitle,
   cancelCallback,
   previousAppliedItemsList,
   previousAppliedItemsListRoles,
   applicationCode,
   previousAppliedItemsListGroups,
   setSelectedItemsForm,
   isStyleTable,
   onSubmitCallback,
   isForm,
   statusQuestionnaire
}) => {
   const [{ sessionUser }, dispatch] = useStateValue()
   const [selectedItems, setSelectedItems] = useState(
      previousAppliedItemsList || []
   )
   const [toggleSelected, setToggleSelected] = useState(false)
   const [availableItemsListToApply, setAvailableItemsListToApply] = useState(
      []
   )
   const { params, onClose, setModal } = usePortalModal()

   const classes = useStyles()

   const onApplyItemsToRow = evt => {
      // onApplyItemsToRowCallback(currentRowIdToApplyItems, selectedItems)
      setSelectedItemsForm(selectedItems)
      cancelCallback(evt)
   }

   const patchRolesAndGroupAction = async (evt, isPublishedAndRemoved) => {
      dispatch({ type: 'OPEN_SPINNER' })

      function createPayload(type) {
         if (type === 'rol') {
            return {
               roles: selectedItems
            }
         } else if (type === 'grupo') {
            return {
               groups: selectedItems
            }
         }
      }
      try {
         const duplicatedQuest =
            isPublishedAndRemoved &&
            (await postToApi(
               `${process.env.REACT_APP_QUESTIONNAIRE_API}/questionnaire/QuestionnairePublished`,
               {
                  questionareId: questionnaireId,
                  question: true
               }
            ))
         const payload = createPayload(typeUser)
         const URL_PATCH_QUESTIONNARIE = `${
            process.env.REACT_APP_QUESTIONNAIRE_API
         }/questionnaire/${duplicatedQuest?.id || questionnaireId}`
         await patchToApi(URL_PATCH_QUESTIONNARIE, payload)
         cancelCallback(evt)
         onSubmitCallback() // Función para refrescar a busqueda y obtener los datos actualizados
         dispatch(
            openSnackBarAction(
               duplicatedQuest
                  ? `La eliminación del ${typeUser} ha sido exitosa`
                  : `Se guardaron corretamente los ${
                       typeUser === 'rol' ? 'roles ' : 'grupos '
                    } seleccionados.`,
               'Info'
            )
         )
      } catch (error) {
         dispatch(
            openSnackBarAction(
               `Ocurrio un error al intentar guardar Roles y Grupos: ${error?.data?.message}`
            )
         )
      } finally {
         dispatch(closeSpinnerAction())
      }
   }

   const isPublishedAndAGroupOrRoleIsRemoved = evt =>
      statusQuestionnaire === QUESTIONNAIRE.PUBLISHED_STATUS &&
      !(
         typeUser === 'rol'
            ? previousAppliedItemsListRoles
            : previousAppliedItemsListGroups
      )?.every(i => evt?.includes(i))

   const patchRolesAndGroupQuestionnarie = async evt => {
      if (
         !userSettingsModule.buscarValorEnUserSettings(
            'operations',
            'EDITAR CUESTIONARIO'
         )
      ) {
         return
      }

      const isPublishedAndRemovedGroupOrRol =
         isPublishedAndAGroupOrRoleIsRemoved(evt)

      if (isPublishedAndRemovedGroupOrRol) {
         return setModal({
            message: (
               <>
                  {`Señor usuario, usted está intentando eliminar un ${typeUser} asignado a un cuestionario publicado, si
                        usted requiere eliminarlo se bajará la publicación`}
                  <br />
                  <p style={{ fontWeight: 400 }}>
                     ¿Desea continuar con la operación?
                  </p>
               </>
            ),
            onConfirm: () =>
               patchRolesAndGroupAction(evt, isPublishedAndRemovedGroupOrRol)
         })
      }
      patchRolesAndGroupAction(evt, false)
   }

   useEffect(() => {
      if (typeUser === 'rol') {
         setAvailableItemsListToApply(allActiveRoles)
         if (!previousAppliedItemsList) {
            setSelectedItems(previousAppliedItemsListRoles)
         }
      }
      if (typeUser === 'grupo') {
         setAvailableItemsListToApply(allActiveGroups)
         if (!previousAppliedItemsList) {
            setSelectedItems(previousAppliedItemsListGroups)
         }
      }
   }, [typeUser, applicationCode])

   const cancelAndReset = e => {
      cancelCallback(e)
      setAvailableItemsListToApply([])
   }
   // Selecionar todos:
   const handleSelectAll = () => {
      if (toggleSelected) {
         setSelectedItems([])
         setToggleSelected(false)
      } else {
         const allIdsItems = availableItemsListToApply?.map(item => item.id)
         setSelectedItems([...allIdsItems])
         setToggleSelected(true)
      }
   }

   return (
      <Grid
         className={
            isStyleTable
               ? classes.popperWindowLayout
               : classes.popperWindowLayoutForm
         }
      >
         <Grid container justify="space-between">
            <Typography
               className={classes.title}
            >{`${popperWindowTitle} Asignados`}</Typography>
            <div
               style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
               }}
            >
               <Button
                  className={classes.cancelButton}
                  color="primary"
                  size="small"
                  onClick={handleSelectAll}
               >
                  {toggleSelected ? 'Deseleccionar todos' : 'Seleccionar todos'}
               </Button>
            </div>
         </Grid>

         <Grid className={classes.listContainer}>
            {availableItemsListToApply < 1 ? (
               <Typography
                  className={classes.title}
               >{`No existen ${popperWindowTitle} para asignar`}</Typography>
            ) : (
               <ItemsListWithPrimaryAction
                  availableItemsListToApply={availableItemsListToApply}
                  selectedItems={selectedItems}
                  setSelectedItems={setSelectedItems}
               />
            )}
         </Grid>
         <Grid
            container
            justify="space-evenly"
            className={classes.buttonContainer}
         >
            <Button className={classes.cancelButton} onClick={cancelAndReset}>
               {TRANSLATE.BUTTONS.CANCEL}
            </Button>
            <Button
               disabled={
                  !userSettingsModule.buscarValorEnUserSettings(
                     'operations',
                     'EDITAR CUESTIONARIO'
                  )
               }
               variant="contained"
               color="primary"
               onClick={() => patchRolesAndGroupQuestionnarie(selectedItems)}
            >
               {TRANSLATE.BUTTONS.APPLY}
            </Button>
         </Grid>
         <PortalModal params={params} onClose={onClose} />
      </Grid>
   )
}

const SelectAndApplyQuestionnarie = ({
   questionnaireId,
   currentRowIdToApplyItems,
   previousAppliedItemsList,
   previousAppliedItemsListRoles,
   previousAppliedItemsListGroups,
   availableItemsListToApply,
   applicationCode,
   onApplyItemsToRowCallback,
   popperButtonText = TRANSLATE.BUTTONS.ROLES,
   popperWindowTitle,
   setSelectedItemsForm,
   setTypeUserForm,
   isStyleTable = true,
   isForm = false,
   onSubmitCallback,
   statusQuestionnaire
}) => {
   const classes = useStyles()
   const [anchorEl, setAnchorEl] = useState(null)
   const [allActiveRoles, setAllActiveRoles] = useState([])
   const [allActiveGroups, setAllActiveGroups] = useState([])
   const [typeUser, setTypeUser] = useState(null)
   const [showViewMultiSelect, setShowViewMultiSelect] = useState(false)

   const isOpen = Boolean(anchorEl)
   const id = isOpen ? 'simple-popper' : undefined

   const handleClickAway = () => {
      if (isOpen) {
         setAnchorEl()
      }
   }

   const handleToggleOpen = event => {
      setAnchorEl(anchorEl ? null : event.currentTarget)
      setTypeUser(null)
      setShowViewMultiSelect(false)
   }

   // ------------- Fetch all roles and group, for aplicaction  -----------------
   async function _getAllRolesAndGroup() {
      const url = `${process.env.REACT_APP_AUTHORIZATION_API}/user/applications/${applicationCode}/rol-group`
      const allRAndG = await getFromApi(url)

      setAllActiveRoles(allRAndG?.roles)
      setAllActiveGroups(allRAndG?.groups)
   }
   const getAllRolesAndGroup = useApiRequest(
      _getAllRolesAndGroup,
      'RolesAndGroup: Consultar roles and grupos'
   )

   useEffect(() => {
      if (!applicationCode || !isOpen) {
         return
      }
      getAllRolesAndGroup()
   }, [applicationCode, isOpen])

   return (
      <ClickAwayListener onClickAway={handleClickAway}>
         <Grid>
            <Button
               className={
                  isStyleTable ? classes.popperButton : classes.popperButtonForm
               }
               aria-describedby={id}
               onClick={handleToggleOpen}
               endIcon={<FilterListIcon fontSize="small" />}
            >
               {popperButtonText}
            </Button>
            <Popper
               id={id}
               open={isOpen}
               anchorEl={anchorEl}
               className={classes.popperContainer}
               disablePortal
            >
               {typeUser && showViewMultiSelect ? (
                  <PopperWindowLayoutMultiSelect
                     questionnaireId={questionnaireId}
                     allActiveRoles={allActiveRoles}
                     allActiveGroups={allActiveGroups}
                     setShowViewMultiSelect={setShowViewMultiSelect}
                     typeUser={typeUser}
                     setTypeUser={setTypeUser}
                     currentRowIdToApplyItems={currentRowIdToApplyItems}
                     availableItemsListToApply={availableItemsListToApply}
                     previousAppliedItemsList={previousAppliedItemsList}
                     previousAppliedItemsListRoles={
                        previousAppliedItemsListRoles
                     }
                     previousAppliedItemsListGroups={
                        previousAppliedItemsListGroups
                     }
                     onApplyItemsToRowCallback={onApplyItemsToRowCallback}
                     popperWindowTitle={typeUser === 'rol' ? 'Roles' : 'Grupos'}
                     cancelCallback={handleToggleOpen}
                     applicationCode={applicationCode}
                     setSelectedItemsForm={setSelectedItemsForm}
                     isStyleTable={isStyleTable}
                     onSubmitCallback={onSubmitCallback}
                     isForm={isForm}
                     statusQuestionnaire={statusQuestionnaire}
                  />
               ) : (
                  <PopperWindowLayout
                     setShowViewMultiSelect={setShowViewMultiSelect}
                     typeUser={typeUser}
                     setTypeUser={setTypeUser}
                     setTypeUserForm={setTypeUserForm}
                     currentRowIdToApplyItems={currentRowIdToApplyItems}
                     availableItemsListToApply={availableItemsListToApply}
                     previousAppliedItemsList={previousAppliedItemsList}
                     onApplyItemsToRowCallback={onApplyItemsToRowCallback}
                     popperWindowTitle={popperWindowTitle}
                     cancelCallback={handleToggleOpen}
                     isStyleTable={isStyleTable}
                     isForm={isForm}
                  />
               )}
            </Popper>
         </Grid>
      </ClickAwayListener>
   )
}

export default SelectAndApplyQuestionnarie
